module.exports = __webpack_public_path__ + "img/up_res_resource.6fa13c28.svg";